let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5oUQI")).then(() => parcelRequire('lx9c3'));